<template>
  <div>
    <div class="mt-4">
      <router-link
        class="btn btn-dark btn-sm btn-primary"
        v-bind:to="'/profile/' + userId + '/messages'"
      >
        <i class="fas fa-arrow-left fa-1x"></i> Terug
      </router-link>
      <div class="bg-white border border-gray rounded p-4 mt-2">
        <div class="row">
          <div class="col-12">
            <h5 class="d-inline">Van:</h5><br>
            <span class="text-muted">{{ message.from_name }}</span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <h5 class="d-inline">Onderwerp:</h5><br>
            <span class="text-muted">{{ message.subject }}</span>
          </div>
        </div>
        <!-- if has attachments -->
        <div class="row mt-3" v-if="this.message.attachments && message.attachments.length">
          <div class="col-12">
            <h5 class="d-inline">Bijlage(n):</h5><br>
            <ol>
              <li v-for="(file, index) in message.attachments" :key="index">
                <a :href="file" target="_blank">{{ file | getFileName }}</a>
              </li>
            </ol>
          </div>
        </div>
        <h4 class="mt-3">Bericht:</h4>
        <p v-html="message.body" class="text-muted leading"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  computed: {},
  data() {
    return {
      message: [],
      userId: null,
      messageId: null,
      apiUrl: process.env.VUE_APP_API_BASE_URL
    };
  },
  mounted() {
    this.messageId = this.$route.params.messageId;
    this.userId = this.$route.params.messageId;

    this.$store
      .dispatch("get", "/api/v1/message/" + this.messageId)
      .then((data) => {
        this.message = data.data.data;
        console.log(this.message);
        let attachments = this.message.attachments.split(',').filter(at => {
          return at != ""
        });
        console.log("Frst", attachments)
        attachments = attachments.map(a => {
          
          let link = a.split('storage/app/public')
          if(link.length <=1) link = a.split('storage')
          return this.apiUrl + '/storage' + link[1]
        })
        console.log(attachments)

        this.message.attachments = attachments
        
      })
      .catch((error) => {
        console.log(error.request);
      });
  },
  filters: {
    getFileName(value) {
      let splitedLink = value.split('/')
      let nameSplited = []
      if(splitedLink.length) {
        nameSplited = splitedLink[splitedLink.length -1].split('.');
      }
      return nameSplited.length ? nameSplited[nameSplited.length -2 ] + '.' + nameSplited[nameSplited.length -1 ] : 'File'
    },
  },
};
</script>

<style lang="css" scoped></style>
